import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FOLLOW_UPS_SUCCESS,
  FETCH_NEARLY_EXHAUSTED_SUCCESS,
  FETCH_NEARLY_EXHAUSTED_TODAY_SUCCESS,
  FETCH_PIF_RENEWAL_TODAY_SUCCESS,
  FETCH_MEMBERSHIP_UPGRADES_TODAY_SUCCESS,
  FETCH_INTROS_EXPIRED_SUCCESS
} from "../sagas/followUp/followUp";
// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FOLLOW_UPS_SUCCESS,
  FETCH_NEARLY_EXHAUSTED_SUCCESS,
  FETCH_NEARLY_EXHAUSTED_TODAY_SUCCESS,
  FETCH_PIF_RENEWAL_TODAY_SUCCESS,
  FETCH_MEMBERSHIP_UPGRADES_TODAY_SUCCESS,
  FETCH_INTROS_EXPIRED_SUCCESS
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export const initialState = {
  followUps: {},
  nearlyExhausted: {},
  nearlyExhaustedToday: {
    nearly_exhausted_today: []
  },
  pifRenewalToday: {},
  membershipUpgradesToday: {},
  introsExpiring: {},
  initialized: false,
  isLoading: true,
  currentUser: {
    permissions: {}
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_FOLLOW_UPS_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      followUps: action.payload.follow_up || state.followUps
    }),
    [FETCH_NEARLY_EXHAUSTED_SUCCESS]: (state, action) => ({
      ...state,
      nearlyExhausted: action.payload.nearly_exhausted_class_packages || state.nearlyExhausted
    }),
    [FETCH_NEARLY_EXHAUSTED_TODAY_SUCCESS]: (state, action) => ({
      ...state,
      nearlyExhaustedToday: action.payload || state.nearlyExhaustedToday
    }),
    [FETCH_PIF_RENEWAL_TODAY_SUCCESS]: (state, action) => ({
      ...state,
      pifRenewalToday: action.payload || state.pifRenewalToday
    }),
    [FETCH_MEMBERSHIP_UPGRADES_TODAY_SUCCESS]: (state, action) => ({
      ...state,
      membershipUpgradesToday: action.payload || state.membershipUpgradesToday
    }),
    [FETCH_INTROS_EXPIRED_SUCCESS]: (state, action) => ({
      ...state,
      introsExpiring: action.payload || state.introsExpiring
    })
  },
  initialState
);
